import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import VnButton from '@ui/components/VnButton';
import { useEffect, useState } from 'react';
import { closeCircleOutline, pencilOutline, saveOutline, settingsOutline } from 'ionicons/icons';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { deleteMaterialAsync, getAllMaterialByWorkOrderIdAsync, updateBulkMaterialAsync } from '@application/features/materials/MaterialThunk';
import HoursandMaterialsTable from './HoursandMaterialsTable';
import { useParams } from 'react-router-dom';
import ModalPopup from '@ui/components/VnModal';
import AddHoursAndMaterialForm from './AddHoursAndMaterialForm';
import './style.css';
import AddHourForm from './AddHoursForm';
import VnConfirmationModel from '@ui/components/VnConfirmationModel';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import { handleRolePermission } from '@infrastructure/helpers';
import { VisserModule } from '@application/common/enums/visser-module';
import { updateModulePermissionsStatusAsync } from '@application/features/workorders/workorderThunk';
import { resetTimer, setModuleLock, unsetModuleLock } from '@application/features/workorders/workorderSlice';
const HoursandMaterialsTab = ({ formData, errors, onFieldChange, onToggelButtonChange, onCalendarChange, disableWorkOrder, isHoursAndMaterialTabBold }) => {
    // const warningMessageRef = useRef<{ resetTimer: () => void } | null>(null);
    const dispatch = useAppDispatch();
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenHoursForm, setIsOpenHoursForm] = useState(false);
    // const [materialsList, setMaterialsList] = useState<MaterialDto[]>([]);
    const [hoursAndMaterialId, setHoursAndMaterialId] = useState(0);
    const [totalQuantity, setTotalQuantity] = useState(0);
    const [inkoop, setInkoop] = useState(0);
    const [verkoop, setVerkoop] = useState(0);
    const [totaalVerkoop, setTotaalVerkoop] = useState(0);
    const [resultaat, setResultaat] = useState(0);
    //---------------------
    const [groupNames, setGroupNames] = useState([]);
    const [totalQuantities, setTotalQuantities] = useState([]);
    const [totalInkoops, setTotalInkoops] = useState([]);
    const [totalVerkoops, setTotalVerkoops] = useState([]);
    const [resultaats, setResultaats] = useState([]);
    const [verkoops, setVerkoops] = useState([]);
    //--------------------
    const [isEditing, setIsEditing] = useState(false);
    const [editedData, setEditedData] = useState(null);
    const { materials } = useAppSelector((state) => state.material);
    //--------------------
    const [isDeleteMaterialConfirmOpen, setIsDeleteMaterialConfirmOpen] = useState(false);
    const [currentMaterialId, setCurrentMaterialId] = useState(null);
    const [isPersistantInfoCustomToasterOpen, setIsPersistantInfoCustomToasterOpen] = useState(false);
    const { id } = useParams();
    useEffect(() => {
        if (id) {
            dispatch(getAllMaterialByWorkOrderIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => {
                // setMaterialsList(res);
                calculations(res);
                if (isHoursAndMaterialTabBold && res.length > 0) {
                    isHoursAndMaterialTabBold(true);
                }
                else {
                    isHoursAndMaterialTabBold && isHoursAndMaterialTabBold(false);
                }
            });
        }
    }, [dispatch, id]);
    const onAddHoursandMaterialClick = async () => {
        var moduleLockStatus = await checkModulelock();
        if (moduleLockStatus == false) {
            setIsOpen(true);
            setHoursAndMaterialId(0);
        }
    };
    const onAddHoursClick = async () => {
        var moduleLockStatus = await checkModulelock();
        if (moduleLockStatus == false) {
            setIsOpenHoursForm(true);
            setHoursAndMaterialId(0);
        }
    };
    async function onMaterialRowClick(rowId) {
        var moduleLockStatus = await checkModulelock();
        if (moduleLockStatus == false) {
            setHoursAndMaterialId(rowId);
            setIsOpen(true);
        }
    }
    async function onHourRowClick(rowId) {
        var moduleLockStatus = await checkModulelock();
        if (moduleLockStatus == false) {
            setHoursAndMaterialId(rowId);
            setIsOpenHoursForm(true);
        }
    }
    function oncloseClicked() {
        if (id)
            dispatch(getAllMaterialByWorkOrderIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => {
                // setMaterialsList(res);
                calculations(res);
                if (isHoursAndMaterialTabBold && res.length > 0) {
                    isHoursAndMaterialTabBold(true);
                }
                else {
                    isHoursAndMaterialTabBold && isHoursAndMaterialTabBold(false);
                }
            });
        setIsOpen(false);
    }
    function onHoursCloseClicked() {
        if (id)
            dispatch(getAllMaterialByWorkOrderIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => {
                //setMaterialsList(res);
                calculations(res);
                if (isHoursAndMaterialTabBold && res.length > 0) {
                    isHoursAndMaterialTabBold(true);
                }
                else {
                    isHoursAndMaterialTabBold && isHoursAndMaterialTabBold(false);
                }
            });
        setIsOpenHoursForm(false);
    }
    function calculations(listOfHoursAndMaterials) {
        const totalNetPrice = listOfHoursAndMaterials
            .filter((x) => x.unit !== 'Uren')
            .reduce((sum, material) => {
            const price = material.netPrice ?? 0;
            const qty = material.quantity ?? 0;
            return sum + price * qty;
        }, 0);
        const totalMaterialVerkoop = listOfHoursAndMaterials
            .filter((x) => x.unit !== 'Uren')
            .reduce((sum, material) => {
            const price = material.sellingPrice ?? 0;
            const qty = material.quantity ?? 0;
            return sum + price * qty;
        }, 0);
        const totalHoursVerkoop = listOfHoursAndMaterials
            .filter((x) => x.unit === 'Uren')
            .reduce((sum, material) => {
            const price = material.sellingPrice ?? 0;
            const qty = material.externalHours ?? 0;
            return sum + price * qty;
        }, 0);
        const totalVerkoop = totalMaterialVerkoop + totalHoursVerkoop;
        const verkoop = listOfHoursAndMaterials
            .filter((x) => x.unit !== 'Uren')
            .reduce((sum, material) => sum + (material.sellingPrice || 0), 0);
        setTotalQuantity(listOfHoursAndMaterials.filter((x) => x.unit === 'Uren').reduce((sum, material) => sum + (material.externalHours || 0), 0));
        setInkoop(totalNetPrice);
        setVerkoop(verkoop);
        setTotaalVerkoop(totalVerkoop);
        setResultaat(totalVerkoop - totalNetPrice);
        //--------------------
        const groupedMaterials = listOfHoursAndMaterials.reduce((grouped, material) => {
            const groupName = material.group || 'overig';
            grouped[groupName] = grouped[groupName] || [];
            grouped[groupName].push(material);
            return grouped;
        }, {});
        const groups = Object.entries(groupedMaterials);
        //--------------------
        const cal_groupNames = [];
        const cal_totalNetPrices = [];
        const cal_totalQuantities = [];
        const cal_totalInkoops = [];
        const cal_Verkoops = [];
        const cal_totalVerkoops = [];
        const cal_resultaats = [];
        groups.forEach(([groupName, materials]) => {
            cal_groupNames.push(groupName);
            const groupNetPrice = materials
                .filter((x) => x.unit !== 'Uren')
                .reduce((sum, material) => {
                const price = material.netPrice ?? 0;
                const qty = material.quantity ?? 0;
                return sum + price * qty;
            }, 0);
            //const groupQuantity = materials.reduce((sum, material) => sum + (material.quantity || 0), 0);
            const groupQuantity = 0;
            cal_totalNetPrices.push(groupNetPrice);
            cal_totalQuantities.push(groupQuantity);
            const groupInkoop = materials
                .filter((x) => x.unit !== 'Uren')
                .reduce((sum, material) => {
                const price = material.netPrice ?? 0;
                const qty = material.quantity ?? 0;
                return sum + price * qty;
            }, 0);
            const groupVerkoop = materials
                .filter((x) => x.unit !== 'Uren')
                .reduce((sum, material) => sum + (material.sellingPrice || 0), 0);
            const groupMaterialVerkoop = materials
                .filter((x) => x.unit !== 'Uren')
                .reduce((sum, material) => {
                const price = material.sellingPrice ?? 0;
                const qty = material.quantity ?? 0;
                return sum + price * qty;
            }, 0);
            const groupHourVerkoop = materials
                .filter((x) => x.unit === 'Uren')
                .reduce((sum, material) => {
                const price = material.sellingPrice ?? 0;
                const qty = material.externalHours ?? 0;
                return sum + price * qty;
            }, 0);
            const groupTotalVerkoop = groupMaterialVerkoop + groupHourVerkoop;
            cal_totalInkoops.push(groupInkoop);
            cal_totalVerkoops.push(groupTotalVerkoop);
            cal_Verkoops.push(groupVerkoop);
            const resultaat = groupTotalVerkoop - groupInkoop;
            cal_resultaats.push(resultaat);
        });
        setGroupNames(cal_groupNames);
        setTotalQuantities(cal_totalQuantities);
        setTotalInkoops(cal_totalInkoops);
        setVerkoops(cal_Verkoops);
        setTotalVerkoops(cal_totalVerkoops);
        setResultaats(cal_resultaats);
    }
    /*Start of Inline Editing Region*/
    useEffect(() => {
        appendDataintoEdit();
    }, [materials]);
    async function onEdit() {
        var moduleLockStatus = await checkModulelock();
        if (moduleLockStatus == false) {
            setIsEditing(true);
        }
    }
    function onSave() {
        if (editedData) {
            for (let i = 0; i < editedData.length; i++) {
                const item = editedData[i];
                if (item.quantity == '') {
                    item.quantity = 0;
                }
                if (item.grossPrice == '') {
                    item.grossPrice = 0;
                }
                if (item.discount == '') {
                    item.discount = 0;
                }
                if (item.netPrice == '') {
                    item.netPrice = 0;
                }
                if (item.sellingPrice == '') {
                    item.sellingPrice = 0;
                }
                item.created = new Date();
            }
            const poppedRow = editedData.pop(); //removing last (always unfilled) row, will add it again if error recieved from backend.
            dispatch(updateBulkMaterialAsync(editedData)).unwrap().then(() => {
                setIsEditing(false);
                dispatch(getAllMaterialByWorkOrderIdAsync(parseInt(id))).unwrap().then((res) => {
                    calculations(res);
                });
            }).catch((error) => {
                if (poppedRow) {
                    const updatedData = [...editedData, poppedRow];
                    setEditedData(updatedData);
                }
            });
        }
    }
    function onCancel() {
        setIsEditing(false);
        appendDataintoEdit();
    }
    function appendDataintoEdit() {
        if (materials) {
            setEditedData((data) => {
                const updatedData = materials.map((material) => ({ ...material }));
                return updatedData;
            });
        }
    }
    function onEditData(data) {
        setEditedData(data);
    }
    /*End of Inline Editing Region*/
    function onCancelMaterialDeleteClicked() {
        setIsDeleteMaterialConfirmOpen(false);
    }
    function onDeleteMaterialClicked() {
        if (currentMaterialId) {
            dispatch(deleteMaterialAsync(currentMaterialId))
                .unwrap()
                .then(() => {
                dispatch(getAllMaterialByWorkOrderIdAsync(parseInt(id)))
                    .unwrap()
                    .then((res) => {
                    calculations(res);
                    if (isHoursAndMaterialTabBold && res.length > 0) {
                        isHoursAndMaterialTabBold(true);
                    }
                    else {
                        isHoursAndMaterialTabBold && isHoursAndMaterialTabBold(false);
                    }
                });
                setIsDeleteMaterialConfirmOpen(false);
            });
        }
    }
    async function onDeleteMaterial(id) {
        var moduleLockStatus = await checkModulelock();
        if (moduleLockStatus == false) {
            setIsDeleteMaterialConfirmOpen(true);
            setCurrentMaterialId(id);
        }
    }
    //-------------------Module Lock Functionality---------------------------
    const checkModulelock = async () => {
        if (formData.id) {
            dispatch(resetTimer());
            // if (warningMessageRef.current) {
            //     warningMessageRef.current.resetTimer();
            // }
            var moduleLockRequestData = {
                moduleId: VisserModule.Werkorder,
                recordId: formData.id
            };
            try {
                const res = await dispatch(updateModulePermissionsStatusAsync(moduleLockRequestData)).unwrap();
                if (res.isModuleAlreadyLocked) {
                    // setIsPersistantInfoCustomToasterOpen(true);
                    dispatch(setModuleLock());
                    return true;
                }
                // setIsPersistantInfoCustomToasterOpen(false);
                dispatch(unsetModuleLock());
                return false;
            }
            catch (error) {
                // setIsPersistantInfoCustomToasterOpen(false);
                dispatch(unsetModuleLock());
                return false;
            }
        }
        return false;
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: 'vn-Material-Add-buttons', children: [isEditing && (_jsxs(_Fragment, { children: [_jsx(VnButton, { icon: closeCircleOutline, customClassName: 'vn-action-button vn-inline-editing-action-button', mode: 'danger', size: 'sm', isDisabled: id && !disableWorkOrder ? false : true, customIconClassName: 'vn-action-button-icon vn-inline-editing-action-button-icon', onClick: () => {
                                    onCancel();
                                }, style: { marginTop: '0px' } }), _jsx(VnButton, { icon: saveOutline, customClassName: 'vn-action-button vn-inline-editing-action-button mr-14', mode: 'primary', size: 'sm', onClick: () => {
                                    onSave();
                                }, type: 'submit', customIconClassName: 'vn-action-button-icon vn-inline-editing-action-button-icon', style: { marginTop: '0px' }, isDisabled: !disableWorkOrder ? false : true })] })), !isEditing && (_jsx(VnButton, { icon: pencilOutline, customClassName: 'vn-action-button-cancel vn-inline-editing-action-button mr-14', mode: 'secondary', size: 'sm', customIconClassName: 'vn-action-button-cancel-icon vn-inline-editing-action-button-icon', onClick: () => {
                            onEdit();
                        }, style: { marginTop: '0px' }, isDisabled: handleRolePermission(Permission.URENENMATERIALEN, PermissionType.Update) && !disableWorkOrder ? false : true })), _jsx(VnButton, { type: 'button', mode: 'primary', size: 'sm', customClassName: 'vn-add-button', icon: settingsOutline, onClick: onAddHoursandMaterialClick, style: { marginRight: '5px' }, isDisabled: isEditing || !(handleRolePermission(Permission.URENENMATERIALEN, PermissionType.Create) && !disableWorkOrder), children: "Toevoegen Materiaal" })] }), _jsxs("div", { className: 'vn-workorder-Container', children: [_jsx(_Fragment, { children: _jsx(HoursandMaterialsTable, { isEditing: isEditing, editedData: editedData, editData: onEditData, onMaterialRowClick: onMaterialRowClick, onHourRowClick: onHourRowClick, deleteMaterial: onDeleteMaterial, disableWorkOrder: disableWorkOrder, formData: formData }) }), _jsxs("div", { className: 'vn-Material-CalculationCard', style: { fontSize: "small" }, children: [_jsx("div", { style: { paddingTop: '6px', paddingLeft: '24px', paddingBottom: '0px' }, children: _jsx("label", { className: 'vn-Calculation-label', children: "Totale berekening" }) }), _jsxs("div", { className: 'row mb-0 vn-Calculation-Row', children: [_jsx("div", { className: 'col-md-2 vn-calculation-label-List', children: _jsxs("ul", { className: 'list-group list-group-flush', children: [_jsx("li", { className: 'list-group-item', children: "Groep:" }), _jsx("li", { className: 'list-group-item', children: "Uren:" }), _jsx("li", { className: 'list-group-item', children: "Inkoop materiaal(\u20AC):" }), _jsx("li", { className: 'list-group-item', children: "Verkoop materiaal(\u20AC):" }), _jsx("li", { className: 'list-group-item fw-bold', children: "Totaal verkoop(\u20AC):" }), _jsx("li", { className: 'list-group-item', children: "Resultaat(\u20AC):" })] }) }), _jsx("div", { className: 'col-md-7', children: _jsxs("div", { className: 'row', children: [_jsxs("div", { className: 'col-md-2 vn-Calculation-Group', children: [_jsx("li", { className: 'list-group-item vn-Group-Text', children: "Totaal" }), _jsx("li", { className: 'list-group-item vn-Group-Text', children: Number(totalQuantity).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }), _jsx("li", { className: 'list-group-item vn-Group-Text', children: Number(inkoop).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }), _jsx("li", { className: 'list-group-item vn-Group-Text', children: Number(verkoop).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }), _jsx("li", { className: 'list-group-item vn-Group-Text', children: Number(totaalVerkoop).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }), _jsx("li", { className: 'list-group-item vn-Group-Text', children: Number(resultaat).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) })] }), groupNames.map((groupName, index) => (_jsx("div", { className: 'col-md-3 vn-Calculation-Group', children: _jsxs("ul", { className: 'list-group list-group-flush', children: [_jsx("li", { className: 'list-group-item vn-Group-Text', children: groupNames[index] }), _jsx("li", { className: 'list-group-item vn-Group-Text', children: Number(totalQuantities[index]).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }), _jsx("li", { className: 'list-group-item vn-Group-Text', children: Number(totalInkoops[index]).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }), _jsx("li", { className: 'list-group-item vn-Group-Text', children: Number(verkoops[index]).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }), _jsx("li", { className: 'list-group-item vn-Group-Text', children: Number(totalVerkoops[index]).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }), _jsx("li", { className: 'list-group-item vn-Group-Text', children: Number(resultaats[index]).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) })] }) }, index)))] }) })] })] })] }), _jsx(ModalPopup, { title: 'Toevoegen Materiaal', content: _jsx(AddHoursAndMaterialForm, { onClose: () => oncloseClicked(), hoursAndMaterialId: hoursAndMaterialId, disableWorkOrder: disableWorkOrder, isHoursAndMaterialTabBold: isHoursAndMaterialTabBold }), onOpen: isOpen, onClose: () => oncloseClicked(), modalWidth: 'lg' }), _jsx(ModalPopup, { title: 'Uren boeken', content: _jsx(AddHourForm, { onClose: () => onHoursCloseClicked(), hoursId: hoursAndMaterialId, workOrderNumber: formData.workOrderNumber, workOrderDescription: formData.description, disableWorkOrder: disableWorkOrder }), onOpen: isOpenHoursForm, onClose: () => onHoursCloseClicked(), modalWidth: 'lg' }), _jsx(VnConfirmationModel, { title: 'Wilt u dit record verwijderen?', onCancel: () => onCancelMaterialDeleteClicked(), onConfirm: () => onDeleteMaterialClicked(), onOpen: isDeleteMaterialConfirmOpen })] }));
};
export default HoursandMaterialsTab;
